import Icon from "@ant-design/icons";
import {Image} from "antd";
import {
    OPIconImg
} from "../../../../assets";


export const MyIcon = (props) => <Image src={OPIconImg} preview={false}/>
